import type { SVGProps } from "react";
export default function SvgCallAnalysisApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 168 192"
			{...props}
		>
			<foreignObject width={151.572} height={179.747} x={0} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1091_1127_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1091_1127)">
				<path
					fill="url(#paint0_linear_1091_1127)"
					fillOpacity={0.6}
					d="m40.156 82.078 6.336-18.216c-2.328-4.645-3.669-9.87-3.669-15.42C42.823 29.417 58.214 14 77.198 14c18.983 0 34.374 15.418 34.374 34.441 0 19.02-15.388 34.441-34.374 34.441-5.52 0-10.717-1.336-15.338-3.65l-18.2 6.356c-2.173.759-4.259-1.331-3.501-3.508z"
				/>
				<path
					stroke="url(#paint1_linear_1091_1127)"
					d="M77.197 14.5c18.707 0 33.875 15.194 33.875 33.941 0 18.746-15.166 33.942-33.875 33.942-5.438 0-10.559-1.317-15.113-3.599l-.189-.095-.2.07-18.2 6.357c-1.776.62-3.485-1.088-2.864-2.872l.102-.295-.002-.003 6.234-17.92.07-.199-.095-.19c-2.295-4.578-3.617-9.726-3.617-15.196 0-18.747 15.168-33.94 33.874-33.941Z"
				/>
			</g>
			<foreignObject width={137.205} height={165.341} x={30.792} y={26.6592}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1091_1127_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter2_ddddi_1091_1127)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="m127.868 99.066-5.064-14.557a27.4 27.4 0 0 0 2.932-12.324c0-15.202-12.3-27.526-27.472-27.526-15.171 0-27.472 12.325-27.472 27.526 0 15.2 12.3 27.525 27.472 27.525 4.411 0 8.565-1.068 12.26-2.918l14.547 5.082c1.736.605 3.404-1.066 2.799-2.805z"
				/>
				<path
					stroke="url(#paint2_linear_1091_1127)"
					strokeOpacity={0.5}
					d="M98.264 45.16c14.894 0 26.972 12.099 26.972 27.025a26.9 26.9 0 0 1-2.88 12.1l-.094.189.07.199 5.064 14.558.015.043c.414 1.29-.771 2.511-2.051 2.166l-.125-.039-14.547-5.08-.199-.07-.189.095a26.8 26.8 0 0 1-12.036 2.864c-14.895 0-26.972-12.1-26.972-27.025 0-14.926 12.077-27.026 26.972-27.026Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M84.294 76.086c2.13 0 3.857-1.73 3.857-3.865a3.86 3.86 0 0 0-3.858-3.865 3.86 3.86 0 0 0-3.858 3.865 3.86 3.86 0 0 0 3.858 3.865"
			/>
			<path
				fill="#FAFF00"
				d="M102.188 72.15a3.86 3.86 0 0 1-3.858 3.866 3.864 3.864 0 0 1-3.858-3.865 3.864 3.864 0 0 1 3.858-3.866 3.864 3.864 0 0 1 3.858 3.866"
			/>
			<path
				fill="#FAFF00"
				d="M112.235 76.086a3.86 3.86 0 0 0 3.858-3.865 3.86 3.86 0 0 0-3.858-3.865 3.86 3.86 0 0 0-3.858 3.865 3.86 3.86 0 0 0 3.858 3.865"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1091_1127"
					x1={75.9686}
					x2={75.9686}
					y1={14}
					y2={85.7467}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1091_1127"
					x1={75.7861}
					x2={49.2522}
					y1={14.7857}
					y2={73.6084}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1091_1127"
					x1={99.3943}
					x2={99.3943}
					y1={44.6592}
					y2={102}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1091_1127_clip_path" transform="translate(0 4)">
					<path d="m40.156 82.078 6.336-18.216c-2.328-4.645-3.669-9.87-3.669-15.42C42.823 29.417 58.214 14 77.198 14c18.983 0 34.374 15.418 34.374 34.441 0 19.02-15.388 34.441-34.374 34.441-5.52 0-10.717-1.336-15.338-3.65l-18.2 6.356c-2.173.759-4.259-1.331-3.501-3.508z" />
				</clipPath>
				<clipPath id="bgblur_1_1091_1127_clip_path" transform="translate(-30.792 -26.66)">
					<path d="m127.868 99.066-5.064-14.557a27.4 27.4 0 0 0 2.932-12.324c0-15.202-12.3-27.526-27.472-27.526-15.171 0-27.472 12.325-27.472 27.526 0 15.2 12.3 27.525 27.472 27.525 4.411 0 8.565-1.068 12.26-2.918l14.547 5.082c1.736.605 3.404-1.066 2.799-2.805z" />
				</clipPath>
				<filter
					id="filter0_ddddi_1091_1127"
					width={151.572}
					height={179.747}
					x={0}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1127" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1127"
						result="effect2_dropShadow_1091_1127"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1127"
						result="effect3_dropShadow_1091_1127"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1127"
						result="effect4_dropShadow_1091_1127"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1127" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1127" />
				</filter>
				<filter
					id="filter2_ddddi_1091_1127"
					width={137.205}
					height={165.341}
					x={30.792}
					y={26.6592}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1127" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1127"
						result="effect2_dropShadow_1091_1127"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1127"
						result="effect3_dropShadow_1091_1127"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1127"
						result="effect4_dropShadow_1091_1127"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1127" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1127" />
				</filter>
			</defs>
		</svg>
	);
}
